//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Skeleton from '@/directives/loading/components/skeleton.vue';
import Feather from '@/directives/loading/components/feather.vue';
import Material from '@/directives/loading/components/material.vue';

export default {
    name: 'Loading',
    components: {
        Skeleton,
        Feather,
        Material
    },
    data () {
        return {
            visible: false,
            hiding: false,
            containerWidth: 0,
            containerHeight: 0
        };
    },
    computed: {
        overlayStyle () {
            const { type, spinnerProps, overlayProps } = this;

            if (type === 'skeleton') {
                return {
                    position: overlayProps.position || 'absolute'
                };
            }

            return {
                'background-color': spinnerProps.background,
                'position': overlayProps.position || 'absolute',
                'justify-content': 'center',
                'grid-gap': '8px'
            };
        }
    },
    methods: {
        /**
         * @public
         */
        setContainerSize ({ width, height }) {
            this.containerHeight = height;
            this.containerWidth = width;
        }
    }
};
